<template>
  <v-card>
    <v-card-title    
      class="grey lighten-2 mb-2"
    >
      {{ title }}
    </v-card-title>
    <v-card-text    
      class="py-1"
    >
      {{ text }}
    </v-card-text>

    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn
        color="primary"
        text
        @click="onClick()"
      >{{ confirmText }}
      </v-btn>
    </v-card-actions>
  </v-card>    
</template>

<script>
import { mapState,  mapMutations } from 'vuex'


export default {
  props: {
    title : {
      type: String,
      default() { return '알림'; }
    },
    text: {
      type: String,
      default() { return '이 페이지는 결제 후 이용이 가능합니다.'; }
    },
    confirmText: {
      type: String,
      default() { return '확인'; }
    },
    goTo: {
      type: String,
      default() { return null; }
    }        
  },
  computed: {
    ...mapState([
      'paymentRequiredDialog'
    ])
  },
  methods: {
    ...mapMutations([
      'showPaymentRequiredDialog',      
    ]),
    onClick() {
      this.showPaymentRequiredDialog(false);
      if (this.goTo) {
        this.$router.push(this.goTo);
      }      
    }
  }
}
</script>